import React from 'react';
import { withTranslation } from 'react-i18next';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error to console
        console.error("ErrorBoundary caught an error:", error, errorInfo);

        const isChunkError = /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(
            (error?.message || '') + ' ' + (error?.name || '') + ' ' + (error?.toString() || '')
        );

        if (isChunkError) {
            const reloaded = sessionStorage.getItem('chunk_error_reloaded');
            if (!reloaded) {
                sessionStorage.setItem('chunk_error_reloaded', '1');
                window.location.reload();
                return;
            }
        }

        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    render() {
        const { t } = this.props;

        if (this.state.hasError) {
            return (
                <div className="not-found">
                    <h2 style={{fontSize: "800%"}}>Oops</h2>
                    <h4>{t('Something went wrong')}</h4>
                    <p>{t('An unexpected error occurred in the application')}</p>
                    <details style={{ whiteSpace: 'pre-wrap', textAlign: 'left', background: 'var(--white-gray)', color: 'var(--easy-black)', padding: '10px', marginTop: '20px', borderRadius: '5px' }}>
                        <summary>{t('Show error details (for developers)')}</summary>
                        <br />
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </details>
                    <button 
                        onClick={() => {
                            sessionStorage.removeItem('chunk_error_reloaded');
                            window.location.reload();
                        }} 
                        style={{ 
                            marginTop: '20px', 
                            padding: '10px 20px', 
                            cursor: 'pointer',
                            background: 'var(--primary-green)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 'var(--border-radius)'
                        }}
                    >
                        {t('Refresh page')}
                    </button>
                </div>
            );
        }

        return this.props.children; 
    }
}

export default withTranslation()(ErrorBoundary);
